import {
  space,
  width,
  maxWidth,
  fontSize,
  color,
  borders,
  borderColor,
  borderRadius,
  boxShadow
} from "styled-system";
import styled from "styled-components";

export default styled.div`
  box-sizing: border-box;
  ${space}
  ${width}
  ${maxWidth}
  ${fontSize}
  ${color}
  ${borders}
  ${borderColor}
  ${borderRadius}
  ${boxShadow}
`;